import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'
import { initAnalytics } from './analytics.js'

initAnalytics()

// Skimlinks: auto-converts outbound links to affiliate links across thousands
// of merchants. Activated only when VITE_SKIMLINKS_ID is set.
const skimId = import.meta.env.VITE_SKIMLINKS_ID
if (skimId) {
  const s = document.createElement('script')
  s.src = `https://s.skimresources.com/js/${encodeURIComponent(skimId)}.skimlinks.js`
  s.async = true
  document.head.appendChild(s)
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)

// Register service worker for offline resilience (production only — avoids
// interfering with Vite HMR in development).
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {})
  })
}
